export default __webpack_public_path__ + "static/media/TestAndRedeployment.dc2b403a.svg";